import SEO from './SEO';

const SuppliersSEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "NABAZAT AL QALB",
    "description": "Trusted medical supplies company in Erbil, Iraq with partnerships with leading global medical equipment manufacturers and pharmaceutical companies",
    "url": "https://nabazatalqalb.com/suppliers",
    "logo": "https://nabazatalqalb.com/logo512.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Erbil",
      "addressRegion": "Arbil",
      "addressCountry": "IQ"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English", "Arabic", "Kurdish"]
    },
    "sameAs": [
      "https://facebook.com/nabazatalqalb",
      "https://twitter.com/nabazatalqalb",
      "https://linkedin.com/company/nabazatalqalb"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Iraq"
    },
    "serviceType": "Medical Supplies and Healthcare Solutions",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Medical Supplies from Trusted Suppliers",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "MedicalDevice",
            "name": "Medical Equipment from Global Manufacturers"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Drug",
            "name": "Pharmaceuticals from Licensed Suppliers"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "MedicalDevice",
            "name": "Healthcare Solutions from Certified Partners"
          }
        }
      ]
    }
  };

  return (
    <SEO
      title="Suppliers"
      description="NABAZAT AL QALB partners with leading global medical equipment manufacturers and pharmaceutical companies. We work with trusted suppliers to provide the highest quality medical supplies and healthcare solutions in Erbil, Iraq."
      keywords="medical suppliers Erbil Iraq, medical equipment suppliers, pharmaceutical suppliers, healthcare partners, medical device manufacturers, trusted medical suppliers, global medical suppliers, medical equipment partners"
      url="https://nabazatalqalb.com/suppliers"
      structuredData={structuredData}
    />
  );
};

export default SuppliersSEO; 